import drivableEquipmentLess from 'assets/img/drivable-equipment-less-than-3000lbs.svg'
import drivableEquipmentMore from 'assets/img/drivable-equipment-more-than-3000lbs.svg'
import parts from 'assets/img/parts.svg'
import buildingMaterial from 'assets/img/building-material.svg'
import towableItem from 'assets/img/towable-item.svg'
import portableEquipment from 'assets/img/portable-equipment.svg'
import pintleHitch from 'assets/img/pintle-hitch.svg'
import twoInchBallHitch from 'assets/img/2-ball-hitch.svg'
import ballHitch from 'assets/img/25-16-ball-hitch.svg'

export const timeOptions = [
  {name: '12:00 AM', value: '00.00'},
  {name: '12:30 AM', value: '00.30'},
  {name: '1:00 AM', value: '01.00'},
  {name: '1:30 AM', value: '01.30'},
  {name: '2:00 AM', value: '02.00'},
  {name: '2:30 AM', value: '02.30'},
  {name: '3:00 AM', value: '03.00'},
  {name: '3:30 AM', value: '03.30'},
  {name: '4:00 AM', value: '04.00'},
  {name: '4:30 AM', value: '04.30'},
  {name: '5:00 AM', value: '05.00'},
  {name: '5:30 AM', value: '05.30'},
  {name: '6:00 AM', value: '06.00'},
  {name: '6:30 AM', value: '06.30'},
  {name: '7:00 AM', value: '07.00'},
  {name: '7:30 AM', value: '07.30'},
  {name: '8:00 AM', value: '08.00'},
  {name: '8:30 AM', value: '08.30'},
  {name: '9:00 AM', value: '09.00'},
  {name: '9:30 AM', value: '09.30'},
  {name: '10:00 AM', value: '10.00'},
  {name: '10:30 AM', value: '10.30'},
  {name: '11:00 AM', value: '11.00'},
  {name: '11:30 AM', value: '11.30'},
  {name: '12:00 PM', value: '12.00'},
  {name: '12:30 PM', value: '12.30'},
  {name: '1:00 PM', value: '13.00'},
  {name: '1:30 PM', value: '13.30'},
  {name: '2:00 PM', value: '14.00'},
  {name: '2:30 PM', value: '14.30'},
  {name: '3:00 PM', value: '15.00'},
  {name: '3:30 PM', value: '15.30'},
  {name: '4:00 PM', value: '16.00'},
  {name: '4:30 PM', value: '16.30'},
  {name: '5:00 PM', value: '17.00'},
  {name: '5:30 PM', value: '17.30'},
  {name: '6:00 PM', value: '18.00'},
  {name: '6:30 PM', value: '18.30'},
  {name: '7:00 PM', value: '19.00'},
  {name: '7:30 PM', value: '19.30'},
  {name: '8:00 PM', value: '20.00'},
  {name: '8:30 PM', value: '20.30'},
  {name: '9:00 PM', value: '21.00'},
  {name: '9:30 PM', value: '21.30'},
  {name: '10:00 PM', value: '22.00'},
  {name: '10:30 PM', value: '22.30'},
  {name: '11:00 PM', value: '23.00'},
  {name: '11:30 PM', value: '23.30'},
]

export const GOOGLE_MAPS_LIBRARIES = ['places']

export const commodityTypes = [
  {
    id: '1',
    name: 'Drivable Equipment <3,000lbs',
    value: 'drivable-equipment-less-than-3000-lbs',
    image: drivableEquipmentLess,
  },
  {
    id: '2',
    name: 'Drivable Equipment >3,000lbs',
    value: 'drivable-equipment-more-than-3000-lbs',
    image: drivableEquipmentMore,
  },
  {
    id: '3',
    name: 'Part',
    value: 'part',
    image: parts,
  },
  {
    id: '4',
    name: 'Building Material',
    value: 'building-material',
    image: buildingMaterial,
  },
  {id: '5', name: 'Towable Item', value: 'towable-item', image: towableItem},
  {
    id: '6',
    name: 'Portable Equipment',
    value: 'portable-equipment',
    image: portableEquipment,
  },
]

export const couplerTypes = [
  {id: '1', name: 'Pintle Hitch', image: pintleHitch},
  {id: '2', name: '2” Ball Hitch', image: twoInchBallHitch},
  {id: '3', name: '25/16”Ball Hitch', image: ballHitch},
]

export const spaceRequiredTypes = [
  {id: '1', name: 'Option 1', image: ''},
  {id: '2', name: 'Option 2', image: ''},
  {id: '3', name: 'Option 3', image: ''},
]

export const grayMapStyle = [
  {
    featureType: 'administrative.locality',
    elementType: 'all',
    stylers: [
      {
        hue: '#2c2e33',
      },
      {
        saturation: 7,
      },
      {
        lightness: 19,
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        hue: '#f8f8f7',
      },
      {
        saturation: -100,
      },
      {
        lightness: 80,
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [
      {
        hue: '#ffffff',
      },
      {
        saturation: -100,
      },
      {
        lightness: 100,
      },
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        hue: '#bbc0c4',
      },
      {
        saturation: -93,
      },
      {
        lightness: 31,
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        hue: '#bbc0c4',
      },
      {
        saturation: -93,
      },
      {
        lightness: 31,
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels',
    stylers: [
      {
        hue: '#bbc0c4',
      },
      {
        saturation: -93,
      },
      {
        lightness: -2,
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        hue: '#e9ebed',
      },
      {
        saturation: -90,
      },
      {
        lightness: -8,
      },
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [
      {
        hue: '#e9ebed',
      },
      {
        saturation: 10,
      },
      {
        lightness: 69,
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        hue: '#e9ebed',
      },
      {
        saturation: -78,
      },
      {
        lightness: 67,
      },
      {
        visibility: 'simplified',
      },
    ],
  },
]

export const ALLOWED_IMAGE_EXT = {
  jpeg: 'jpeg',
  jpg: 'jpg',
  png: 'png',
  gif: 'gif',
  bmp: 'bmp',
  webp: 'webp',
}
export const ALLOWED_IMAGE_SIZE = 10

export const cancelationReasons = [
  'Driver did not show up',
  'No drivers available',
  'Unable to reach the driver (please try calling or chat via the App)',
  'Customer did not show up',
  'Test',
]

export const activeOrdersTabs = [
  {name: 'Open Load', value: 'open-load'},
  {name: 'Assigned Load', value: 'assigned-load'},
  {name: 'Enroute To Pickup', value: 'enroute-to-pickup'},
  {name: 'Enroute to Delivery', value: 'enroute-to-delivery'},
]

export const defaultShippingHours = [
  {
    day: 'Monday',
    set: false,
    startTime: '12:00 AM',
    endTime: '12:00 AM',
  },
  {
    day: 'Tuesday',
    set: false,
    startTime: '12:00 AM',
    endTime: '12:00 AM',
  },
  {
    day: 'Wednesday',
    set: false,
    startTime: '12:00 AM',
    endTime: '12:00 AM',
  },
  {
    day: 'Thursday',
    set: false,
    startTime: '12:00 AM',
    endTime: '12:00 AM',
  },
  {
    day: 'Friday',
    set: false,
    startTime: '12:00 AM',
    endTime: '12:00 AM',
  },
  {
    day: 'Saturday',
    set: false,
    startTime: '12:00 AM',
    endTime: '12:00 AM',
  },
  {
    day: 'Sunday',
    set: false,
    startTime: '12:00 AM',
    endTime: '12:00 AM',
  },
]
